function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { CoreVideoInternal } from '../../core-video-internal';
import { AdsFailoverReason } from '../../core/player/playout-data';
import { AdvertsManagerState } from './adverts-manager-stage.enums';
export { AdvertsManagerState } from './adverts-manager-stage.enums';
export var AdvertsInitialisationStageManager = /*#__PURE__*/ function() {
    "use strict";
    function AdvertsInitialisationStageManager(adInsertionClientConfig) {
        _class_call_check(this, AdvertsInitialisationStageManager);
        _define_property(this, "adInsertionClientConfig", void 0);
        _define_property(this, "initialisationState", void 0);
        this.adInsertionClientConfig = adInsertionClientConfig;
        this.initialisationState = AdvertsManagerState.Uninitialised;
    }
    _create_class(AdvertsInitialisationStageManager, [
        {
            key: "initialise",
            value: function initialise(sessionItem, initialPlayoutData) {
                var _this_adInsertionClientConfig, _sessionItem_adInsertion, _initialPlayoutData_advertising, _CoreVideoInternal_getPropositionExtensions_adsDisabled_CoreVideoInternal_deviceType, _CoreVideoInternal_getPropositionExtensions_adsDisabled;
                if (!((_this_adInsertionClientConfig = this.adInsertionClientConfig) === null || _this_adInsertionClientConfig === void 0 ? void 0 : _this_adInsertionClientConfig.enabled) || ((_sessionItem_adInsertion = sessionItem.adInsertion) === null || _sessionItem_adInsertion === void 0 ? void 0 : _sessionItem_adInsertion.disabled)) {
                    this.initialisationState = AdvertsManagerState.Disabled;
                    return initialPlayoutData;
                }
                if ((_initialPlayoutData_advertising = initialPlayoutData.advertising) === null || _initialPlayoutData_advertising === void 0 ? void 0 : _initialPlayoutData_advertising.isKillswitchEnabled) {
                    this.initialisationState = AdvertsManagerState.Disabled;
                    return _object_spread_props(_object_spread({}, initialPlayoutData), {
                        adsFailoverReason: AdsFailoverReason.Killswitch
                    });
                }
                if (!initialPlayoutData.vamPrerollEnabled && !initialPlayoutData.vamMidrollEnabled) {
                    this.initialisationState = AdvertsManagerState.Disabled;
                    return initialPlayoutData;
                }
                if ((_CoreVideoInternal_getPropositionExtensions_adsDisabled = CoreVideoInternal.getPropositionExtensions().adsDisabled) === null || _CoreVideoInternal_getPropositionExtensions_adsDisabled === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_adsDisabled_CoreVideoInternal_deviceType = _CoreVideoInternal_getPropositionExtensions_adsDisabled[CoreVideoInternal.deviceType]) === null || _CoreVideoInternal_getPropositionExtensions_adsDisabled_CoreVideoInternal_deviceType === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_adsDisabled_CoreVideoInternal_deviceType.call(_CoreVideoInternal_getPropositionExtensions_adsDisabled, sessionItem)) {
                    this.initialisationState = AdvertsManagerState.Disabled;
                    return initialPlayoutData;
                }
                this.initialisationState = AdvertsManagerState.Initialised;
                return initialPlayoutData;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.initialisationState = AdvertsManagerState.Uninitialised;
            }
        },
        {
            key: "isDisabled",
            value: function isDisabled() {
                return this.initialisationState === AdvertsManagerState.Disabled;
            }
        },
        {
            key: "getInitialisationStatus",
            value: function getInitialisationStatus() {
                return this.initialisationState;
            }
        }
    ]);
    return AdvertsInitialisationStageManager;
}();

//# sourceMappingURL=adverts-initialisation-stage-manager.js.map